import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';

function Navigation() {
  const location = useLocation();
  
  return (
    <nav className="navigation">
      <div className="nav-brand">
        <h1>Motion Picture Censorship</h1>
      </div>
      <div className="nav-links">
        <Link 
          to="/" 
          className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
        >
          <i className="fas fa-film"></i> Upload
        </Link>
      </div>
    </nav>
  );
}

export default Navigation; 